module.exports = __webpack_public_path__ + "img/alert-icon.9d367e5c.svg";